<template>
    <div v-if="geometry" class="payroll-scroll-header" :style="geometry.frame" aria-label="Закреплённые названия столбцов">
        <table ref="head" :style="geometry.table"><colgroup><col v-for="(width, index) in geometry.widths" :key="index" :style="{width: `${width}px`}"></colgroup>
            <thead><tr><th><span class="sr-only">Выбор</span></th>
                <th v-for="column in columns" :key="column.key" scope="col" :title="column.scopeTitle" :aria-sort="sortKey === column.key ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'">
                    <PayrollColumnHeading compact v-bind="column" :active="sortKey === column.key" :direction="direction" :group-by-object="column.key === 'employee' ? groupByObject : null" @sort="$emit('sort', column.key)" @grouping="$emit('grouping', $event)" />
                </th><th scope="col"><PayrollColumnHeading compact label="Действия" :scope="groupByObject ? 'По объекту' : 'За весь месяц'" :scope-kind="groupByObject ? 'object' : 'month'" :sortable="false" /></th>
            </tr></thead>
        </table>
        <div v-if="groupByObject && geometry.objectName" class="payroll-scroll-object" aria-label="Текущий объект">
            <span>Объект</span><strong :title="geometry.objectName">{{ geometry.objectName }}</strong>
        </div>
    </div>
</template>
<script>
import PayrollColumnHeading from './PayrollColumnHeading.vue';
export default {
    components: {PayrollColumnHeading},
    props: {columns: Array, sortKey: String, direction: String, active: Boolean, groupByObject: Boolean},
    data: () => ({geometry: null}),
    mounted() {
        this.schedule = () => {
            if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.measure(); });
        };
        window.addEventListener('scroll', this.schedule, true);
        window.addEventListener('resize', this.schedule);
        if (typeof ResizeObserver !== 'undefined') this.observer = new ResizeObserver(this.schedule);
        this.$nextTick(this.schedule);
    },
    watch: {active() { this.$nextTick(this.schedule); }, columns() { this.$nextTick(this.schedule); }, groupByObject() { this.$nextTick(this.schedule); }},
    beforeDestroy() {
        window.removeEventListener('scroll', this.schedule, true);
        window.removeEventListener('resize', this.schedule);
        if (this.observer) this.observer.disconnect();
        if (this.tableObserver) this.tableObserver.disconnect();
        cancelAnimationFrame(this.frame);
    },
    methods: {
        measure() {
            const root = this.$parent.$el;
            if (!root || !root.querySelector) return;
            const period = root.querySelector('.work-period-bar'), filters = root.querySelector('.payroll-active-filters');
            const anchor = root.querySelector('.payroll-period-anchor'), spacer = root.querySelector('.payroll-period-spacer');
            if (period && anchor && spacer) {
                const stickyTop = parseFloat(getComputedStyle(period).top) || 0;
                const stuck = anchor.getBoundingClientRect().bottom < stickyTop;
                if (!period.classList.contains('is-stuck')) {
                    this.expandedPeriodHeight = period.getBoundingClientRect().height + (parseFloat(getComputedStyle(period).marginBottom) || 0);
                }
                period.classList.toggle('is-stuck', stuck);
                const height = period.getBoundingClientRect().height + (parseFloat(getComputedStyle(period).marginBottom) || 0);
                // Preserve document height so shrinking cannot bounce across the sticky threshold.
                spacer.style.height = stuck ? `${Math.max(0, this.expandedPeriodHeight - height)}px` : '0px';
            }
            const targets = [root, period, filters, this.$refs.head].filter(Boolean);
            if (this.observer && (!this.observed || targets.some((element, index) => this.observed[index] !== element) || targets.length !== this.observed.length)) {
                this.observer.disconnect();
                targets.forEach(element => this.observer.observe(element));
                this.observed = targets;
            }
            const top = period ? (parseFloat(getComputedStyle(period).top) || 0) + period.getBoundingClientRect().height : 0;
            root.style.setProperty('--payroll-filter-top', `${top}px`);
            if (!this.active || window.innerWidth <= 900) { this.geometry = null; return; }
            const filterRect = filters && filters.getBoundingClientRect();
            const headerTop = filterRect ? Math.max(top + filterRect.height, filterRect.bottom) : top;
            const table = Array.from(root.querySelectorAll('.payroll-table')).find(table => {
                const rect = table.getBoundingClientRect();
                return rect.width && rect.top < headerTop && rect.bottom > headerTop + 36;
            });
            if (this.sourceTable !== table) {
                if (this.tableObserver) this.tableObserver.disconnect();
                this.sourceTable = table;
                if (table && typeof MutationObserver !== 'undefined') {
                    this.tableObserver = new MutationObserver(this.schedule);
                    this.tableObserver.observe(table, {childList: true, subtree: true, characterData: true});
                }
            }
            if (!table) { this.geometry = null; return; }
            const rect = table.getBoundingClientRect(), wrap = table.parentElement.getBoundingClientRect();
            const left = Math.max(0, wrap.left), width = Math.min(innerWidth, wrap.right) - left;
            const headingHeight = this.$refs.head ? this.$refs.head.getBoundingClientRect().height : 0;
            const boundary = headerTop + headingHeight;
            const object = this.groupByObject && Array.from(table.querySelectorAll('.payroll-object-heading'))
                .filter(row => row.getBoundingClientRect().top <= boundary).pop();
            const name = object && object.querySelector('.payroll-object-title > strong');
            this.geometry = {
                frame: {top: `${headerTop}px`, left: `${left}px`, width: `${width}px`, maxHeight: `${Math.max(0, rect.bottom - headerTop)}px`},
                table: {width: `${rect.width}px`, transform: `translateX(${rect.left - left}px)`},
                objectName: name ? name.textContent.trim() : '',
                widths: Array.from(table.tHead.rows[0].cells).map(cell => cell.getBoundingClientRect().width)
            };
            if (!this.$refs.head) this.$nextTick(this.schedule);
        }
    }
};
</script>
<style scoped>
.payroll-scroll-header { position: fixed; z-index: 1007; overflow: hidden; background: #f8fafc; border-bottom: 1px solid #cbd5e1; box-shadow: 0 3px 8px #24364b0a; }
table { table-layout: fixed; border-collapse: collapse; }
th { padding: 4px 6px; vertical-align: bottom; text-align: left; }
.payroll-scroll-object { display: flex; align-items: baseline; gap: 8px; min-width: 0; padding: 4px 10px; border-left: 4px solid #111827; color: #fff; background: #374151; font-size: 13px; line-height: 20px; }
.payroll-scroll-object > span { flex: 0 0 auto; color: #d0d8e3; font-size: 10px; text-transform: uppercase; letter-spacing: .04em; }
.payroll-scroll-object > strong { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600; }
</style>
